import React from 'react'
import 'styles/d3/dropdown.scss'

/*

props: options - array of options { key: 'key', value: 'key', text: 'text' }

*/

class Dropdown extends React.Component {
  constructor(props) {
    super(props)
    this.state = { open: false }
    this.textMap = {}
    this.updateTextMap(props.options)
  }

  handleOpen = e => {
    if (this.props.disabled) return
    if (this.props.onOpen) this.props.onOpen()
    if (!this.state.open) {
      this.setState({ open: true })
    }
  }

  updateTextMap = options => {
    if (options) {
      this.textMap = {}
      options.forEach(item => {
        this.textMap[item.key] = item.text
      })
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.clickListener)
  }

  componentDidUpdate(prevProps) {
    if (this.props.options && prevProps.options !== this.props.options) {
      this.updateTextMap(this.props.options)
    }
  }

  handleClose = e => {
    if (this.props.onClose) this.props.onClose()
    if (this.state.open) {
      this.setState({ open: false })
    }
  }

  handleCloseTriggers = e => {
    if (e.target.dataset.closetrigger === 'true') this.handleClose()
  }

  clickListener = e => {
    if (!this.props.disabled) {
      if (!this.el.contains(e.target)) this.handleClose()
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.clickListener)
  }

  onSelectItem(item) {
    if (this.props.disabled) return
    return e => {
      const newState = { selectedText: item.text }
      this.props.onSelect(item, e)
      if (!this.props.preventCloseOnSelect) newState.open = false
      this.setState(newState)
    }
  }

  render() {
    const {
      selected,
      children,
      options,
      className,
      selectedIdx,
      renderFunction,
      main,
      disabled,
      hideCaret
    } = this.props
    const hasDropdown = children || (options && options.length > 0)
    let _className = `d3-dropdown${className ? ` ${className}` : ''}`
    _className += disabled ? ' disabled' : ''
    _className += hasDropdown && this.state.open ? ' open' : ''
    return (
      <div
        tabIndex='0'
        ref={el => {
          this.el = el
        }}
        className={_className}
        id={this.props.id}>
        <div
          onClick={this.state.open ? this.handleClose : this.handleOpen}
          className='dropbar'>
          <div className='dropbar-content'>
            {main || this.textMap[selected]}
          </div>
          {hasDropdown && !hideCaret && (
            <i className={`fas fa-angle-${this.state.open ? 'up' : 'down'}`} />
          )}
        </div>
        {hasDropdown && (
          <div onClick={this.handleCloseTriggers} className='menu'>
            {children ||
              options.map((item, idx) => {
                const isSelected = selectedIdx
                  ? selectedIdx === idx
                  : selected === item.value
                return (
                  <div
                    key={item.key || `item_${idx}`}
                    onClick={this.onSelectItem(item)}
                    className={`dropdown-item clickable${isSelected ? ' selected' : ''
                      }`}>
                    {renderFunction
                      ? renderFunction(item, this.props)
                      : item.text}
                  </div>
                )
              })}
          </div>
        )}
      </div>
    )
  }
}

export default Dropdown
